import { useMediaQuery, useSafeLayoutEffect } from '@hover/blueprint/chakra';
import { useState } from 'react';

import {
  DEFAULT_TOOLBAR_MIN_LENGTH,
  GUEST_TOOLBAR_MIN_LENGTH,
  PARTNER_GUEST_TOOLBAR_MIN_LENGTH,
  PARTNER_TOOLBAR_MIN_LENGTH,
} from 'src/modules/designStudio/components/Toolbar/toolBarConstants';
import { isServer as getIsServer } from 'src/shared/helpers/environment';

const useShouldCenterToolbar = (
  isLandscape: boolean,
  displayDisabled: boolean,
  displayVersionReset: boolean,
): boolean => {
  const isServer = getIsServer();
  const [shouldCenterToolbar, setShouldCenterToolbar] = useState(false);
  const [largerThanDefault] = useMediaQuery(
    `(min-width: ${DEFAULT_TOOLBAR_MIN_LENGTH}px)`,
  );
  const [largerThanPartner] = useMediaQuery(
    `(min-width: ${PARTNER_TOOLBAR_MIN_LENGTH}px)`,
  );
  const [largerThanGuest] = useMediaQuery(
    `(min-width: ${GUEST_TOOLBAR_MIN_LENGTH}px)`,
  );
  const [largerThanPartnerGuest] = useMediaQuery(
    `(min-width: ${PARTNER_GUEST_TOOLBAR_MIN_LENGTH}px)`,
  );

  useSafeLayoutEffect(() => {
    if (!isServer && !isLandscape) {
      if (displayDisabled && displayVersionReset) {
        setShouldCenterToolbar(largerThanDefault);
      } else if (displayDisabled) {
        setShouldCenterToolbar(largerThanGuest);
      } else if (displayVersionReset) {
        setShouldCenterToolbar(largerThanPartner);
      } else {
        setShouldCenterToolbar(largerThanPartnerGuest);
      }
    } else {
      setShouldCenterToolbar(false);
    }
  }, [
    isServer,
    isLandscape,
    displayDisabled,
    displayVersionReset,
    largerThanDefault,
    largerThanGuest,
    largerThanPartner,
    largerThanPartnerGuest,
  ]);

  return shouldCenterToolbar;
};

export { useShouldCenterToolbar };
